/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

// Messages
import messages from './messages/ReportFooter_messages';

const ReportFooter = () => (
  <Footer>
    <FormattedMessage
      {...messages.bodyText}
      info="Suomen Tilaajavastuu Oy ei vastaa käyttäjälle tai kolmannelle.."
    />
  </Footer>
);

const Footer = styled.div`
  font-size: ${props => props.theme['font-size-small']};
  line-height: ${props => props.theme['line-height-small']};
  margin: 24px;
`;

export default ReportFooter;
